<!-- 
CAMPO PARA INFORMAR PERIODO - UTILIZADO EM CONSULTAS

EVENTOS:
  change(startDate, endDate)

COMO USAR:
    <div class="col-md-3 col-6">
        <input-month p-month="monthObj" @change="periodoChange"></input-month>
    </div>
-->

<template>
  <div class="d-flex">
      <div class="form-group form-group-sm d-flex">
        <!-- <div class="form-control form-control-sm" style="width: 200px; justify-content: space-between;">
          <span class="dropdown-toggle" data-toggle="dropdown" style="width: 100%; border-radius: 0%" >{{ label }}</span>
           <span class="caret"></span>
          <div class="dropdown-menu">
              <a class="dropdown-item" href="javascript:void(0);" v-for="action in options" :key="action.action" 
                  @click="clickAction(action.action)">{{ action.label }}</a>
          </div>
        </div> -->
        <div class="form-control form-control-sm" data-toggle="dropdown" style="width: 28px; justify-content: space-between;">
          <span class="dropdown-toggle"></span>
        </div>
        <div class="dropdown-menu">
            <a class="dropdown-item" href="javascript:void(0);" v-for="action in options" :key="action.action" 
                @click="clickAction(action.action)">{{ action.label }}</a>
        </div>
      </div>
      <div class="ml-3"></div>
      <form-field class="align-items-center" ref="start" v-model="start" type="date"></form-field>
      <div class="ml-3"></div>
      <form-field ref="end" v-model="end" type="date"></form-field>
      <span v-if="showButtons" style="cursor: pointer; font-size: 18px" title="Mês Anterior" @click="clickMesAnterior()"><i class="fa fa-chevron-left ml-3" aria-hidden="true"></i></span>
      <span v-if="showButtons" style="cursor: pointer; font-size: 18px" title="Próximo Mês" @click="clickProximoMes()"><i class="fa fa-chevron-right ml-3" aria-hidden="true"></i></span>
  </div>
</template>

<script>
import { formatValue, formatDate } from '../shared/utils'

export default {
    props: {
      pMonth: { type: Object },
      showOptions: { type: Boolean },
    },

    data () {
      return {
        month: 0,
        year: 0,
        label: '',
        start: Date,
        end: Date,
        inputingDates: false,
        showButtons: true,
        options: [],
        listMonth: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],

        unWatch: false,
      }
    },

    mounted () {

    },

    methods: {
      formatValue: function() {
        let v = this.$refs.valor.value
        this.$refs.valor.value = formatValue(this.$strToFloat(v, this.precision), this.precision)
        this.focused = false
      },

      handleMesAtual () {
        let today = new Date()
        this.year = Number(today.getFullYear())
        this.month = today.getMonth()
        this.label = this.listMonth[this.month] + '/' + this.year
        let m = this.month + 1
        this.start = this.$firstDay(this.year + '-' + m + '-01')
        this.end = this.$lastDay(this.year + '-' + m + '-01')
        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        this.inputingDates = false
        this.showButtons = true
      },

      handlePeriodo () {
        this.label = 'Período específico'
        this.inputingDates = false
        this.showButtons = false
      },

      clickAction (action) {
        if (action == 1) {
          //mes atual
          this.handleMesAtual()
        } else 
        if (action == 2) {
          //semana atual
          this.label = 'Semana atual'
          this.start = this.$getDate();
          this.end = this.$addDays(this.$getDate(), 7);
          this.showButtons = false
          this.inputingDates = false
        } else
        if (action == 3) {
          //ultimos 30 dias
          this.start = this.$addDays(this.$getDate(), -30)
          this.end = this.$getDate()
          this.showButtons = false
          this.inputingDates = false
          this.label = 'Últimos 30 dias'
        } else 
        if (action == 4) {
          //Este ano
          let today = new Date()
          this.year = Number(today.getFullYear())
          this.start = this.$firstDay(this.year + '-01' + '-01')
          this.end = this.$lastDay(this.year + '-12' + '-31')
          this.showButtons = false
          this.inputingDates = false
          this.label = 'Este Ano'
        } else 
        if (action == 5) {
          this.inputingDates = true
          this.label = 'Período específico'
          this.$nextTick(function () {
            this.$refs.start.focus()
          })
        } else
        if (action == 8) {
          //ultimos 6 meses
          let today = new Date()
          today.setMonth(today.getMonth() -6);
          this.month = today.getMonth() + 1
          this.start = this.$firstDay(today.getFullYear() + '-' + this.month + '-01')
          this.end = this.$getDate()
          this.showButtons = false
          this.inputingDates = false
          this.label = 'Últimos 6 meses'
        } else
        if (action == 9) {
          //ultimos 12 meses
          let today = new Date()
          today.setMonth(today.getMonth() -12);
          this.month = today.getMonth() + 1
          this.start = this.$firstDay(today.getFullYear() + '-' + this.month + '-01')
          this.end = this.$getDate()
          this.showButtons = false
          this.inputingDates = false
          this.label = 'Últimos 12 meses'
        }
        this.updatePeriodo()
      },

      clickProximoMes () {
        this.unWatch = true
        if (!this.month){
          let today = new Date()
          this.month = today.getMonth();
          this.year = today.getFullYear();
        }
        if (this.month == 11) {
          this.year++
          this.month = 0
        } else {
          this.month++
        }
        this.label = this.listMonth[this.month] + '/' + this.year
        let m = this.month + 1
        this.start = this.$firstDay(this.year + '-' + m + '-01')
        this.end = this.$lastDay(this.year + '-' + m + '-01')
        this.updatePeriodo()
      },

      clickMesAnterior () {
        this.unWatch = true
        if (!this.month){
          let today = new Date()
          this.month = today.getMonth();
          this.year = today.getFullYear();
        }
        if (this.month == 0) {
          this.year--
          this.month = 11
        } else {
          this.month--
        }
        this.label = this.listMonth[this.month] + '/' + this.year
        let m = this.month + 1
        this.start = this.$firstDay(this.year + '-' + m + '-01')
        this.end = this.$lastDay(this.year + '-' + m + '-01')
        this.updatePeriodo()
      },

      updatePeriodo () {
        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        this.$emit('change', this.start, this.end)
      }

    },

    watch: {

      end: function () {
        if (this.pMonth.endDate != this.end) {
          this.label = 'Período específico'
          this.updatePeriodo()
        }
      },

      start: function () {
        if (this.pMonth.startDate != this.start) {
          this.label = 'Período específico'
          this.updatePeriodo()
        }
      },

    },

    created () {

      if (!this.pMonth.startDate){
        this.start = null 
        this.end = null 
        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        //this.handleMesAtual()
      }else {
        this.start = this.pMonth.startDate
        this.end = this.pMonth.endDate

        if (this.start){
          let today = new Date(this.start+'T00:00:00')
          this.year = Number(today.getFullYear())
          this.month = today.getMonth()
 
        }
      }


      //if (this.showOptions) {
        var act = {}
        act = { action: 1, label: 'Este Mês' }
        this.options.push(act) 
        act = { action: 2, label: 'Esta Semana' }
        this.options.push(act)
        act = { action: 3, label: 'Últimos 30 dias' }
        this.options.push(act)
        act = { action: 7, label: 'Últimos 3 meses' }
        this.options.push(act)
        act = { action: 8, label: 'Últimos 6 meses' }
        this.options.push(act)
        act = { action: 9, label: 'Últimos 12 meses' }
        this.options.push(act)
        act = { action: 4, label: 'Este ano' }
        this.options.push(act)
        act = { action: 6, label: 'Ano Anterior' }
        this.options.push(act)
        act = { action: 5, label: 'Período Específico' }
        this.options.push(act)
      //}

    },


}
</script>

<style scoped>

input {
  width: 100%;
  
}

.dropdown-total {
    z-index: 1051;
    margin-top: 3px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    padding: 10px;
    z-index: 1000;
    float: left;
    min-width: 160px;
    list-style: none;
    background-color: #fff;
    border: 1px solid #00000033;
    box-shadow: 0 5px 10px #00000033;
    background-clip: padding-box;
}    

</style>



// WEBPACK FOOTER //
// src/components/input-month2.vue